"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var currency_1 = require("@nerdwallet/currency");
var button_1 = __importDefault(require("../../button"));
var close_button_1 = __importDefault(require("./close-button"));
var introducing_card_1 = require("../introducing-card");
var nerdwallet_plus_logo_1 = require("../../nerdwallet-plus-logo");
var nerdwallet_plus_drawer_module_css_1 = __importDefault(require("../nerdwallet-plus-drawer.module.css"));
var drawer_context_1 = require("../drawer-context");
var ONBOARDING_LINK = "/home/nerdwallet-plus/onboarding-banking";
var Drawer = function (_a) {
    var _b = _a.ctaLinkOverride, ctaLinkOverride = _b === void 0 ? ONBOARDING_LINK : _b, _c = _a.ctaText, ctaText = _c === void 0 ? "GET STARTED" : _c, _d = _a.drawerWidth, drawerWidth = _d === void 0 ? 0 : _d, _e = _a.drawerHeight, drawerHeight = _e === void 0 ? 0 : _e;
    var _f = (0, drawer_context_1.useDrawerContext)(), isOpen = _f.isOpen, close = _f.close, onCtaClick = _f.onCtaClick;
    var theme = (0, material_1.useTheme)();
    var isMobile = (0, material_1.useMediaQuery)(theme.breakpoints.down("sm"));
    var onCustomCtaClick = function () {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) {
            window.location.href = ctaLinkOverride;
        }
        close();
        onCtaClick();
    };
    var drawerStyle = {
        font: "",
        "&::-webkit-scrollbar": {
            width: "12px",
        },
        "&::-webkit-scrollbar-track": {
            borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
            borderRadius: "10px",
            background: "lightgray",
        },
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(material_1.Drawer, { anchor: "left", open: isOpen, onClose: close, style: drawerStyle, PaperProps: {
                sx: {
                    bottom: "0%",
                    top: isMobile ? "0%" : "unset",
                    borderRadius: {
                        xs: "0",
                        sm: "0 1rem 1rem 0",
                    },
                    width: {
                        xs: "100%",
                        sm: drawerWidth ? "".concat(drawerWidth, "%") : "22rem",
                    },
                    height: {
                        sm: "100%",
                        md: drawerHeight ? "".concat(drawerHeight, "%") : "unset",
                    },
                },
            } },
            react_1.default.createElement(currency_1.Box, { paddingX: 4, paddingY: 4, className: nerdwallet_plus_drawer_module_css_1.default.drawerContentContainer },
                react_1.default.createElement(close_button_1.default, null),
                react_1.default.createElement(currency_1.Box, { marginBottom: 3 },
                    react_1.default.createElement(introducing_card_1.IntroducingCard, null)),
                react_1.default.createElement(currency_1.Box, { marginBottom: 3 },
                    react_1.default.createElement(currency_1.Type, { className: nerdwallet_plus_drawer_module_css_1.default.greenDarkestText }, "Join NerdWallet+ to start racking up rewards. All you have to do to earn $100 in rewards is:")),
                react_1.default.createElement(currency_1.Box, { className: nerdwallet_plus_drawer_module_css_1.default.drawerListContainer },
                    react_1.default.createElement(currency_1.List, null,
                        react_1.default.createElement(currency_1.Li, null,
                            react_1.default.createElement(currency_1.Type, { display: "block", size: "1" },
                                "Use NerdWallet to find and open an eligible bank account \u2014 eligible accounts are marked with the",
                                " ",
                                react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { height: 18, small: true }),
                                " label")),
                        react_1.default.createElement(currency_1.Li, null,
                            react_1.default.createElement(currency_1.Type, { display: "block", size: "1" }, "Link your bank account to your NerdWallet account within 7 days")),
                        react_1.default.createElement(currency_1.Li, null,
                            react_1.default.createElement(currency_1.Type, { display: "block", size: "1" }, "Make a direct deposit within 45 days")),
                        react_1.default.createElement(currency_1.Li, null,
                            react_1.default.createElement(currency_1.Type, { display: "block", size: "1" }, "Redeem your rewards in the NerdWallet+ rewards portal")))),
                react_1.default.createElement(currency_1.Box, { marginTop: 2 },
                    react_1.default.createElement(currency_1.Type, { size: "1", display: "block" }, "Make more smart financial moves (like linking your credit score and monitoring your cash flow) and you could earn even more \u2014 up to $350 in rewards each year. It\u2019s easy to earn back your annual membership fee of $49, and then some. Cancel anytime.")),
                react_1.default.createElement(currency_1.Box, { paddingTop: 4, width: 100, className: nerdwallet_plus_drawer_module_css_1.default.buttonWidth100 },
                    react_1.default.createElement(button_1.default, { onClick: onCustomCtaClick }, ctaText))))));
};
exports.default = Drawer;
